// extracted by mini-css-extract-plugin
module.exports = {"radioText":"_2tIdb-2o"};